module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/education-quiz.b81937a1f70dbbc0cbf5ae3f73df91a0.jpg";